/**
  Author: Ravinder Singh - ravinder.singh@enabledata.com
  Purpose: Report services
  Date: Sept 2020
**/

import API from '../utils/api';
import LocalStorageService from './localStorage';
const localStorageService = LocalStorageService.getService();

export const getStandardReportList = () => {
  return API.get(`reporting/standard-reports`, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const getEventLogs = (payload) => {
  return API.get(`settings/user-logs?${payload}`, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const getStandardReport = (id) => {
  return API.get(`reporting/standard-reports/${id}`, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const getSourceList = () => {
  return API.get(`users/api-consumers`, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const getCustomReportList = () => {
  return API.get(`reporting/custom-reports`, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const getCustomReport = (id) => {
  return API.get(`reporting/custom-reports/${id}`, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const getDataList = (url) => {
  return API.get(url);
};

export const addCustomReport = (data) => {
  return API.post(`reporting/custom-reports`, data, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const downloadUserLogs = (data) => {
  return API.post(`settings/download-user-logs`, data, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const updateCustomReport = (data) => {
  return API.put(`reporting/custom-reports/${data.PK}`, data, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const deleteCustomReport = (data) => {
  return API.delete(
    `reporting/report/${encodeURIComponent(data.reportId)}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorageService.getAccessToken()}`,
      },
    },
  );
};

export const getReportresultList = (id) => {
  return API.get(`reporting/report/${id}`, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const getReportFile = (id) => {
  return API.get(`reporting/download/${id}`, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const userNotifications = () => {
  return API.get(`users/notifications`, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};


export const getPreSignedUrl = (data) => {
  return API.post(`reporting/pre-signed-url`, data, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const postCustomReportMetaData = (data) => {
  return API.post(`reporting/custom-reports`, data, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};
export const updateCustomReportMetaData = (PK,data) => {
  return API.put(`reporting/custom-reports/mod/meta/${encodeURIComponent(PK)}`, data, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};
export const updateCustomReportMetaQuery = (PK,data) => {
  return API.put(`reporting/custom-reports/mod/query/${encodeURIComponent(PK)}`, data, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const updatPublicPrivateStatus = (data) => {
  return API.post(`settings/patch/custom_reports`, data, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};